<script>
/**
 *     dateChangedCallback (date) {
 *       this.forms.collected_date = date
 *     },
 *
 *     <cs-date-picker
 *                 :date.sync="forms.collected_date"
 *                 :min-date="minimumDate"
 *                 :max-date="maximumDate"
 *                 @dateChangedCallback="dateChangedCallback"
 *               >
 *                 <template v-slot="{ on, attrs }">
 *                   <validation-provider
 *                     v-slot="{ errors }"
 *                     :rules="{required: true}"
 *                     class="requiredMark"
 *                     name="引渡し日"
 *                   >
 *                     <v-text-field
 *                       v-model="forms.collected_date"
 *                       v-bind="attrs"
 *                       v-on="on"
 *                       :error-messages="errors"
 *                       append-icon="mdi-calendar"
 *                       clearable
 *                       dense
 *                       hide-details="auto"
 *                       label="引渡し日"
 *                       outlined
 *                       persistent-hint
 *                       persistent-placeholder
 *                       readonly
 *                     />
 *                   </validation-provider>
 *                 </template>
 *               </cs-date-picker>
 *
 */
export default {
  name: "CsDatePicker",
  props: {
    date: {
      type: String,
      default: () => null,
    },
    minimumDate: {
      type: String,
      default: () => null,
    },
    maximumDate: {
      type: String,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: 'date'
    },
  },
  data() {
    return {
      pickerMenu: false,
      pickerDate: null,
    }
  },
  watch: {
    pickerMenu (value) {
      this.pickerDate = null;
      if (value) {
        this.pickerDate = this.$props.date
      }
    }
  },
  methods: {
    inputChangeEvent () {
      this.$emit('dateChangedCallback', this.pickerDate)
      this.pickerMenu = false
    }
  }
}
</script>

<template>
  <v-menu
    v-model="pickerMenu"
    :disabled="disabled"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot v-bind="{ on, attrs }" />
    </template>
    <v-date-picker
      v-model="pickerDate"
      :disabled="disabled"
      :min="minimumDate"
      :max="maximumDate"
      :type="type"
      color="primary"
      class="customDatePicker"
      :day-format="(date) => new Date(date).getDate()"
      @input="inputChangeEvent"
    />
  </v-menu>
</template>

